import { Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';

interface IDialog {
  visible?: boolean
  cancel?: any
  ok?: any
}

@Component
export default class Dialog extends tsx.Component<IDialog> {
  
  @Prop() public visible?: boolean
  @Prop() public cancel?: any
  @Prop() public ok?:  any
  
  render() {
    const {cancel = () => {}, ok= () => {}, visible} = this.$props;
    return visible ?  (
      <div class='dialog-container'>
        <div class='content-container'>
          <div class='top-container'>
            {this.$slots.default}
          </div>
          <div class='bottom-container'>
            <div onClick={ok} class='left'>
              确定
            </div>
            <div class='line'></div>
            <div onClick={cancel}  class='right'>
              取消
            </div>
          </div>
        </div>
      </div>
    ) : null
  }
  
}